const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
// Ball Is Art Design System Loader
(function () {
  var selfScript = document.querySelector('script[src*="constants.js"]');
  if (!selfScript) return;
  var base = selfScript.src.replace(/\/constants\.js.*$/, '/');
  // Google Fonts — Roboto Slab · Inter · JetBrains Mono
  var gf = document.createElement('link');
  gf.rel = 'stylesheet';
  gf.href = 'https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;600;700;900&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap';
  document.head.appendChild(gf);
  // Ball Is Art Design System CSS
  var bia = document.createElement('link');
  bia.rel = 'stylesheet';
  bia.href = base + 'bia-design-system.css';
  document.head.appendChild(bia);
  // Ball Is Art Product Page CSS
  var prod = document.createElement('link');
  prod.rel = 'stylesheet';
  prod.href = base + 'bia-product.css';
  document.head.appendChild(prod);
})();
